import Vuejs from 'vue'

export default {
  install (Vue, { i18n }) {
    let local = {}

    local.getRoute = (name) => {
      return { name: i18n.locale + '/' + name }
    }

    Vue.prototype.$local = local
  }
}
